import PROFANITY_RAW from "../data/profanity_ru_ua.txt?raw";

function normalizeToken(token: string): string {
  return token
    .normalize("NFKC")
    .trim()
    .toLowerCase()
    .replace(/ё/g, "е");
}

function parseWordList(raw: string): Set<string> {
  const words = new Set<string>();
  const text = String(raw ?? "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  for (const line of text.split("\n")) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith("#")) continue;
    const word = normalizeToken(trimmed);
    if (word) words.add(word);
  }
  return words;
}

let cachedWords: Set<string> | null = null;

export function getProfanityWordSet(): Set<string> {
  if (!cachedWords) cachedWords = parseWordList(PROFANITY_RAW);
  return cachedWords;
}

const TOKEN_RE = /[0-9a-zа-яё'’`_-]+/giu;

export function findProfanityMatches(text: string): string[] {
  if (!text) return [];
  const words = getProfanityWordSet();
  const matches: string[] = [];
  for (const match of String(text).matchAll(TOKEN_RE)) {
    const token = String(match[0] ?? "");
    const normalized = normalizeToken(token);
    if (normalized && words.has(normalized)) matches.push(token);
  }
  return Array.from(new Set(matches.map((match) => match.trim()).filter(Boolean)));
}

export function hasProfanity(text: string): boolean {
  return findProfanityMatches(text).length > 0;
}

export function profanityMessage(matches: string[]): string {
  const visible = matches.slice(0, 3).join(", ");
  return visible
    ? `Нельзя использовать ненормативную лексику: ${visible}.`
    : "Нельзя использовать ненормативную лексику.";
}
